import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const EditButton = (props: { link?: string | undefined; }) => {
    const { link } = props;
    const navigate = useNavigate();

    const editClick = () => {
        if (link) {
            navigate(`${link}`);
        }
    };

    return (
        <div className='d-grid gap-2 d-flex justify-content-end mt-4'>
            <Button
                variant='btn btn-tertiary'
                onClick={editClick}
            >
                <i className='icon-edit me-1' aria-hidden='true' />
                Edit
                <span className='visually-hidden'>this section</span>
            </Button>
        </div>
    );
};

export default EditButton;
